import React from "react";
import { Stack } from "@mui/material";
import SubActionButton from "@quest_editor/components/Buttons/SubActionButton";
import { useTranslation } from "react-i18next";
import { Link, useSearchParams } from "react-router-dom";
import { usePromotions } from "@quest_editor/mocks";
import OverviewPanel from "./OverviewPanel";
import TablePanel, { PromotionFilters } from "./TablePanel";

const PromotionList = () => {
  const { t } = useTranslation("questEditor");
  const [searchParams, setSearchParams] = useSearchParams();

  const getParamValue = (key: string) => searchParams.get(key) || "";

  const { data } = usePromotions();
  const rows = data?.promotions ?? [];

  const [filters, setFilters] = React.useState<PromotionFilters>({
    idName: getParamValue("idName"),
    type: getParamValue("type"),
    status: getParamValue("status"),
    owner: getParamValue("owner"),
  });
  const [page, setPage] = React.useState(
    Number(getParamValue("page")) || 0,
  );
  const rowsPerPage = 25;

  React.useEffect(() => {
    setFilters({
      idName: getParamValue("idName"),
      type: getParamValue("type"),
      status: getParamValue("status"),
      owner: getParamValue("owner"),
    });
    setPage(Number(getParamValue("page")) || 0);
  }, [searchParams]);

  const handleFilterChange = (key: keyof PromotionFilters, value: string) => {
    setFilters((prev) => ({ ...prev, [key]: value }));
  };

  const handleSearch = () => {
    const params = new URLSearchParams();
    if (filters.idName) params.set("idName", filters.idName);
    if (filters.type) params.set("type", filters.type);
    if (filters.status) params.set("status", filters.status);
    if (filters.owner) params.set("owner", filters.owner);
    params.set("page", "0");
    setSearchParams(params);
    setPage(0);
  };

  const handlePageChange = (newPage: number) => {
    const params = new URLSearchParams(searchParams);
    params.set("page", String(newPage));
    setSearchParams(params);
    setPage(newPage);
  };

  const idName = getParamValue("idName");
  const type = getParamValue("type");
  const status = getParamValue("status");
  const owner = getParamValue("owner");

  const filteredRows = rows.filter((row) => {
    return (
      (idName === "" ||
        row.id.includes(idName) ||
        row.name.includes(idName)) &&
      (type === "" || row.type === type) &&
      (status === "" || row.status === status) &&
      (owner === "" || row.owner === owner)
    );
  });

  const start = page * rowsPerPage;
  const pageRows = filteredRows.slice(start, start + rowsPerPage);
  const pageCount = Math.ceil(filteredRows.length / rowsPerPage);

  return (
    <Stack direction="column" flexGrow={1} sx={{ flex: 1, minHeight: 0 }}>
      <OverviewPanel />

      <Stack
        direction="row"
        spacing={2}
        alignSelf="flex-end"
        sx={{ mt: 4, mb: 2 }}
      >
        <SubActionButton
          component={Link}
          to="promotion/register"
        >
          {t("home.button.register")}
        </SubActionButton>
        <SubActionButton
          component={Link}
          to="quest/progress"
        >
          {t("home.button.progress")}
        </SubActionButton>
      </Stack>

      <TablePanel
        pageRows={pageRows}
        filteredTotal={filteredRows.length}
        filters={filters}
        onFilterChange={handleFilterChange}
        onSearch={handleSearch}
        page={page}
        pageCount={pageCount}
        onPageChange={handlePageChange}
      />

      <SubActionButton
        component={Link}
        to="audit_log"
        sx={{ alignSelf: "flex-start", mt: 2 }}
      >
        {t("home.button.audit_logs")}
      </SubActionButton>
    </Stack>
  );
};
export default PromotionList;
